<ng-container *ngIf="!eventService.loadEventTournaments;else loading">



    <mat-tab-group class="shawarmer-tabs">

        <div class="snow"></div>


        <mat-tab label="tab2">

            <ng-template mat-tab-label>
                <a (click)="currentCity?return():null" style="color:#fff; padding:20px;">
                    <i class="icon icon-shield"></i>
                    <span> اختار المدينة</span>
                </a>
            </ng-template>

            <div class="disclaimer" *ngIf="game == 'fifa' ">
                <i class=" glyphicon glyphicon-info-sign"></i>
                <p>This tournament is not affiliated with or sponsored by Electronic Arts Inc. or its licensors.</p>
            </div>
            <div *ngIf="!currentCity" class="city-container">
                <div class="city-block" *ngFor="let city of cities" (click)="changeCity(city)"
                     [ngStyle]="{'background-image': 'url(assets/img/shawarmer/'+city+'.jpg)'}">
                    <div class="city-block-background" [ngClass]="city">
                    </div>
                    <p>{{city}}</p>
                </div>
            </div>
            <div *ngIf="currentCity">
                <div class="tournaments-title-bar">
                    <i class="item glyphicon glyphicon-chevron-left" (click)="return()"></i>
                    <div class="item" style="text-transform: uppercase;" (click)="return()">{{game}}</div>
                    <div class="item">{{currentCity}}</div>

                </div>

                <div class="shawarmer-tournament-container"
                     *ngFor="let tournament of (eventService.eventTournaments|async)?.data| searchPipe: currentCity:'city'">
                    <div class="tournament-details">
                        <div class="row">
                            <a class="col-md-5 col-xs-12 zero_margin"
                               href="https://www.gbarena.com/tournaments/{{tournament.code}}"
                               target="_blank">
                                <div class="tournament-item" style="border-bottom: 1px solid #1f2240;">
                                    <img *ngIf="tournament?.profile_picture" [src]="tournament?.profile_picture"
                                         alt="Tournament Profile">
                                        <h1>{{tournament?.name}}</h1>
                                </div>
                            </a>

                            <div class="col-md-7 col-xs-12 zero_margin">
                                <div class="row">
                                    <div class="col-xs-4 zero_margin">
                                        <div class="tournament-item">
                                        <!--Tournament Satrt at-->
                                        <i class="icon-calendar"></i>
                                        <p style="margin: 10px 0; direction: ltr !important;">
                                            {{globalService.Date(tournament.start_at)}}
                                        </p>
                                        </div>
                                    </div>

                                    <div class="col-xs-4 zero_margin">
                                        <div class="tournament-item">

                                        <i class="icon-clock"></i>
                                        <p style="direction: ltr !important;">
                                            {{globalService.Time(tournament.start_at)}}
                                        </p>
                                        </div>
                                    </div>

                                    <div class="col-xs-4 zero_margin">
                                        <div class="tournament-item">
                                        <div class="status">
                                            <div class="status"
                                                 *ngIf="tournament.status == 'Waiting Players to Join'">
                                                <div class="icon active"></div>
                                                <p>{{language?.Tournament_status.Waiting_players_to_join}}</p>
                                            </div>
                                            <div class="status" *ngIf="tournament.status== 'Finished'">
                                                <div class="icon finished"></div>
                                                <p>{{language?.Tournament_status.Finished}}</p>
                                            </div>
                                            <div class="status" *ngIf="tournament.status == 'Registration Closed'">
                                                <div class="icon postponed"></div>
                                                <p>{{language?.Tournament_status.Registration_Closed}}</p>
                                            </div>
                                            <div class="status" *ngIf="tournament.status == 'In Progress'">
                                                <div class="icon inprogress"></div>
                                                <p>{{language?.Tournament_status.In_Progress}}</p>
                                            </div>
                                            <div class="status" *ngIf="tournament.status == 'Cancelled'">
                                                <div class="icon cancelled"></div>
                                                <p>{{language?.Tournament_status.Cancelled}}</p>
                                            </div>
                                        </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </div>
                </div>


            </div>


        </mat-tab>

        <!--<mat-tab label="tab2" id="test">-->
        <!--<ng-template mat-tab-label>-->
        <!--<i class="icon-trophy"></i>-->
        <!--Winners-->
        <!--</ng-template>-->
        <!--<div *ngIf="currentCity">-->

        <!--<div style="margin:10px 0;"-->
        <!--*ngFor="let tournament of (eventService.eventTournaments|async)?.data| searchPipe: currentCity:'city'">-->
        <!--<div class="col-sm-4">-->
        <!--<a class="tag-container" href="https://www.gbarena.com/tournaments/{{tournament.code}}"-->
        <!--target="_blank">-->
        <!--<div class="tag">-->
        <!--<div class="tag-side tag-3-side">-->
        <!--<div class="tag-text tag-3-text">-->
        <!--<div class="snow"></div>-->
        <!--&lt;!&ndash;<div class="tag-cover" [ngStyle]="{'background-image': 'url('+tournament.cover_picture+')'}">&ndash;&gt;-->
        <!--&lt;!&ndash;</div>&ndash;&gt;-->
        <!--<div class="text">-->
        <!--<h1>{{tournament.name}}</h1>-->
        <!--<h2>Winners</h2>-->
        <!--<div class="flex_block row_wrap"-->
        <!--*ngIf="tournament.winners?.length>0 ;else noWinners">-->
        <!--<div class="winner" *ngFor="let winner of tournament.winners">-->
        <!--<img src="{{winner.participant_avatar}}"/>-->
        <!--<p class="zero_margin">{{winner.participant_name}}</p>-->
        <!--</div>-->
        <!--</div>-->
        <!--<ng-template #noWinners>-->
        <!--<div class="big_block christmas_message">-->
        <!--<p class="zero_margin">No Winners yet.</p>-->
        <!--</div>-->
        <!--</ng-template>-->
        <!--</div>-->

        <!--<div class="rule-shape">&#10052;</div>-->
        <!--</div>-->
        <!--</div>-->


        <!--</div>-->
        <!--</a>-->

        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</mat-tab>-->

    </mat-tab-group>


    <div *ngIf="currentCity">
        <div class="big_block"
             style="background:#233354; border-radius:5px; font-family: 'FrutigerLTArabic-55Roman', sans-serif"
             *ngIf="((eventService.eventTournaments|async)?.data| searchPipe: currentCity:'city')?.length==0">
            <div class="content text-center">
                <p>لا يوجد بطولات بعد</p>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #loading>
    <app-loading-indicator></app-loading-indicator>
</ng-template>
